import { fg } from '@atlaskit/platform-feature-flags/fg';

import type { EditionAwarenessContextType } from './edition-awareness-context';
import { isEligibleForStandardToPremium } from './is-eligible-for-standard-to-premium';
import { isProductOneOf } from './is-product-one-of';

export function isEligibleForStandardToPremiumIncentiveOffer(
	context: EditionAwarenessContextType,
): boolean {
	const { product, isInCollection } = context;

	return (
		isEligibleForStandardToPremium(context) &&
		isProductOneOf(product, ['jira', 'confluence']) &&
		// On paid standard, we know the site is standalone if this is not IN_COLLECTION
		isInCollection !== 'IN_COLLECTION' &&
		fg('standard_to_premium_incentive_offer_ea_kill_switch')
	);
}
